"use strict";
import { CONNECTOR_ICON_OVERRIDE_MAP } from "components/Web3Provider/constants";
import { useAccount } from "hooks/useAccount";
import styled from "styled-components";
import { Flex } from "ui/src";
const WalletImage = styled.img`
  width: ${({ size }) => size ? size + "px" : "32px"};
  height: ${({ size }) => size ? size + "px" : "32px"};
`;
export function WalletIcon({ size }) {
  const { connector } = useAccount();
  if (!connector) {
    return null;
  }
  const icon = CONNECTOR_ICON_OVERRIDE_MAP[connector.id] ?? connector.icon;
  return <Flex data-testid="walletIcon" borderRadius={"$roundedFull"} overflow="hidden">
      <Flex transform="scale(1.07)" backgroundColor={"neutral3"}>
        <WalletImage size={size} src={icon} alt={`${connector.name} icon`} />
      </Flex>
    </Flex>;
}
